import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subject } from 'rxjs';
import { Employee } from '../../../../employee/models/Employee';
import { ImportFileResponse, ImportFileResponseEmployee } from '../../../state/import.model';
import { ImportService } from '../../../state/import.service';
import { ImportListComponent } from '../import-list/import-list.component';

export type ImportEntityType = 'EMPLOYEE' | 'REAL_WAGE' | 'PROPERTY' | 'DIRECTIVE' | 'ATTENDANCE';
export type ImportUrlType = 'imports/employees' | 'imports/real-wages' | 'imports/properties' | 'employees/import-holidays' | 'imports/attendance';

@Component({
    selector: 'app-import-by-entity',
    templateUrl: './import-by-entity.component.html',
    styleUrls: ['./import-by-entity.component.css']
})
export class ImportByEntityComponent implements OnInit {
    @ViewChild('importList') public importList: ImportListComponent;

    public entity: ImportEntityType;
    public apiUrl: ImportUrlType;
    public uploadedFile: File;
    public processFileQueue$: Observable<void>;
    public clearFileQueue$: Observable<void>;
    public employees: Array<Employee>;
    public isCollapsed = true;
    public submitted = false;
    public importFileResponse: ImportFileResponse;
    public importFileResponseEmployee: ImportFileResponseEmployee;
    public confirmImportForm: FormGroup;

    private _clearFileQueue$ = new Subject<void>();
    private _processFileQueue$ = new Subject<void>();

    public constructor(
        private _translateService: TranslateService,
        private _importService: ImportService,
        private _router: Router,
        private _fb: FormBuilder
    ) { }

    public ngOnInit(): void {
        this.setCurrentEntity();
        this.clearFileQueue$ = this._clearFileQueue$;
        this.processFileQueue$ = this._processFileQueue$;
    }

    public addedFile($event: File): void {
        this.uploadedFile = $event;
        this._importService.importByEntity(this.uploadedFile, this.apiUrl, false)
            .then((importFileResponse) => {
                    if (this.entity === 'EMPLOYEE') {
                        this.importFileResponseEmployee = importFileResponse as ImportFileResponseEmployee;
                    } else {
                        this.importFileResponse = importFileResponse as ImportFileResponse;
                    }

                    if (this.entity === 'REAL_WAGE') {
                        this.importFileResponse.required_rates.forEach(row =>
                            (this.confirmImportForm.get('rates') as FormGroup).addControl(row.label, this._fb.control(null))
                        );
                    }
                },
                () => {});
    }

    public confirmImport(): void {
        this._importService.importByEntity(this.uploadedFile, this.apiUrl, true, this.confirmImportForm?.value)
            .then(() => {
                    this.importFileResponse = null;
                    this.importFileResponseEmployee = null;
                    this.uploadedFile = null;
                    // todo refresh import list below
                    this.importList.refreshData();
                },
                () => {});
    }

    public downloadTemplate(): void {
        this._importService.downloadTemplate(this.entity, this._translateService.currentLang);
    }

    public setCurrentEntity(): void {
        this.confirmImportForm = this._fb.group({});
        switch (this._router.url) {
            case '/import/real-wages':
                this.entity = 'REAL_WAGE';
                this.apiUrl = 'imports/real-wages';
                this.confirmImportForm = this._fb.group({
                    rates: this._fb.group({})
                });
                break;
            case '/import/properties':
                this.entity = 'PROPERTY';
                this.apiUrl = 'imports/properties';
                break;
            case '/import/employees':
                this.entity = 'EMPLOYEE';
                this.apiUrl = 'imports/employees';
                break;
            case '/import/directives':
                this.entity = 'DIRECTIVE';
                this.apiUrl = 'employees/import-holidays';
                break;
            case '/import/attendance':
                this.entity = 'ATTENDANCE';
                this.apiUrl = 'imports/attendance';
                break;
            default:
        }
    }
}
